import React, { useEffect, useState } from 'react';
import { Modal, Button, Alert, Row, DatePicker } from 'antd';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

const MODE_COPY = {
  grant: {
    title: 'Aktiviraj VIP članstvo',
    confirmLabel: 'Aktiviraj VIP',
    confirmLabelLoading: 'Aktiviranje...',
    prompt: (userName) =>
      `Aktivirajte besplatno VIP članstvo za korisnika ${userName} do izabranog datuma.`,
  },
  extend: {
    title: 'Produži VIP članstvo',
    confirmLabel: 'Produži VIP',
    confirmLabelLoading: 'Produživanje...',
    prompt: (userName) =>
      `Izmenite datum važenja VIP članstva za korisnika ${userName}.`,
  },
};

const VipValidUntilModal = ({
  isOpen,
  onClose,
  onConfirm,
  loading,
  userName,
  mode,
  currentValidUntil,
}) => {
  const [date, setDate] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setDate(currentValidUntil ? dayjs(currentValidUntil) : null);
      setError('');
    }
  }, [isOpen, currentValidUntil]);

  const validate = () => {
    if (!date) {
      setError('Izaberite datum.');
      return false;
    }
    if (date.endOf('day').isBefore(dayjs())) {
      setError('Datum mora biti u budućnosti.');
      return false;
    }
    setError('');
    return true;
  };

  const handleOk = async () => {
    if (!validate()) return;
    await onConfirm(date.endOf('day').toISOString());
  };

  const handleCancel = () => {
    setDate(null);
    setError('');
    onClose();
  };

  const copy = MODE_COPY[mode];

  return (
    <Modal
      className="create_user_modal"
      title={copy.title}
      open={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button
          key="confirm"
          type="primary"
          onClick={handleOk}
          className="btn-primary"
          disabled={loading}
          style={{ width: '150px' }}
        >
          {loading ? copy.confirmLabelLoading : copy.confirmLabel}
        </Button>,
      ]}
    >
      <form className="create_user_modal_form" autoComplete="off">
        <Row className="create_user_modal_row">
          <p style={{ marginBottom: 12 }}>{copy.prompt(userName)}</p>
          <div>
            <DatePicker
              value={date}
              onChange={(value) => {
                setDate(value);
                setError('');
              }}
              format="DD.MM.YYYY."
              placeholder="Izaberite datum"
              disabledDate={(current) =>
                current && current < dayjs().startOf('day')
              }
              style={{ width: '100%' }}
            />
          </div>
        </Row>

        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
      </form>
    </Modal>
  );
};

VipValidUntilModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  userName: PropTypes.string,
  mode: PropTypes.oneOf(['grant', 'extend']).isRequired,
  currentValidUntil: PropTypes.string,
};

export default VipValidUntilModal;
